import * as React from 'react';

const SvgOfferSent = props => {
  const { size, fill } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={fill}
      {...props}
    >
      <path d="M18 12.08V4.586L13.414 0H2a2 2 0 00-2 2v18a2 2 0 002 2h10.683A6.978 6.978 0 0118 12.08zM9 15H3v-2h6zm3-4H3V9h9zm0-10l5 5h-5zm7 13.585l-4.707 4.707 1.414 1.414L18 18.413V24h2v-5.587l2.293 2.293 1.414-1.414L19 14.585z" />
    </svg>
  );
};

export default SvgOfferSent;
